import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useState } from "react";

const accessibilityOptions = [
  "Wheelchair accessible",
  "Ground floor access",
  "Elevator access",
  "Step-free access",
  "Wide doorways",
  "Accessible bathroom",
  "Roll-in shower",
  "Visual aids",
  "Audio aids",
  "Service animal friendly"
];

interface AccessibilityNeedsProps {
  selected: string[];
  onSelect: (needs: string[]) => void;
}

export const AccessibilityNeeds = ({ selected, onSelect }: AccessibilityNeedsProps) => {
  const [open, setOpen] = useState(false);

  const toggleNeed = (need: string) => {
    if (selected.includes(need)) {
      onSelect(selected.filter(item => item !== need));
    } else {
      onSelect([...selected, need]);
    }
  };

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">Accessibility Needs</label>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            role="combobox"
            aria-expanded={open}
            className="w-full justify-between"
          >
            {selected.length === 0 
              ? "Select accessibility needs..." 
              : `${selected.length} selected`}
            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-full p-0">
          <Command>
            <CommandInput placeholder="Search accessibility options..." />
            <CommandEmpty>No option found.</CommandEmpty>
            <CommandGroup>
              {accessibilityOptions.map((need) => (
                <CommandItem
                  key={need}
                  value={need}
                  onSelect={() => toggleNeed(need)}
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4",
                      selected.includes(need) ? "opacity-100" : "opacity-0"
                    )}
                  />
                  {need}
                </CommandItem>
              ))}
            </CommandGroup>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
};